import React from "react";
import PageLayout from "./PageLayout";
import Pillar from "../sections/Pillar";

export default function PsychologyPage() {
    return (
        <PageLayout testId="psychology-page" pageTitle="Psixoloq və fərdi yanaşma">
            <Pillar standalone />
        </PageLayout>
    );
}
